import { createSelector } from '@ngrx/store';
import { selectRootState } from 'app/store/root/root.state';
import * as fromDocuments from './documents.reducer';

export const devDocumentsState = createSelector(
  selectRootState,
  state => state.documents,
);

export const rootDocuments = createSelector(
  selectRootState,
  state => fromDocuments.selectAll(state.documents),
);
